export const SET_SMALL_SMARTPHONE_PORTRAIT = 'SET_SMALL_SMARTPHONE_PORTRAIT';
export const SET_SMARTPHONE_PORTRAIT = 'SET_SMARTPHONE_PORTRAIT';
export const SET_SMARTPHONE_LANDSCAPE = 'SET_SMARTPHONE_LANDSCAPE';
export const SET_TABLET_LANDSCAPE = 'SET_TABLET_LANDSCAPE';
export const SET_DESKTOP = 'SET_DESKTOP';
export const SET_SCROLLBAR_WIDTH = 'SET_SCROLLBAR_WIDTH';
export const ENABLE_OFFLINE_MODE = 'ENABLE_OFFLINE_MODE';

export default {
  // Media query related
  SET_SMALL_SMARTPHONE_PORTRAIT,
  SET_SMARTPHONE_PORTRAIT,
  SET_SMARTPHONE_LANDSCAPE,
  SET_TABLET_LANDSCAPE,
  SET_DESKTOP,
  // Get the width of the scrollbar
  SET_SCROLLBAR_WIDTH,
  // Enable/Disable offline mode
  ENABLE_OFFLINE_MODE,
};
